import { useMemo } from "react";

import { type Category } from "~/api/products/types";

import { useKioskProductsCategories } from "./use-kiosk-products-categories";
import { useKioskActiveCategoryId } from "./use-kiosk-session";

export const useKioskActiveCategory = (): Category | null => {
  const categories = useKioskProductsCategories();
  const activeCategoryId = useKioskActiveCategoryId();

  return useMemo(() => {
    if (categories.length === 0) {
      return null;
    }

    if (!activeCategoryId) {
      return categories[0];
    }

    return (
      categories.find((category) => category.id === activeCategoryId) ?? null
    );
  }, [categories, activeCategoryId]);
};
